"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const angular = require("angular");
const common_1 = require("@angular/common");
const angular_hybrid_1 = require("@uirouter/angular-hybrid");
const core_1 = require("@angular/core");
const static_1 = require("@angular/upgrade/static");
const platform_browser_1 = require("@angular/platform-browser");
const forms_1 = require("@angular/forms");
const http_1 = require("@angular/common/http");
require("@uirouter/core");
const authentication_module_1 = require("./authentication/authentication.module");
const dnaR_dropdown_multiSelect_module_1 = require("./common/components/dnaR-dropdown-multiSelect/dnaR-dropdown-multiSelect.module");
const reporting_module_1 = require("./reporting/reporting.module");
const independent_living_module_1 = require("./independent-living/independent-living.module");
const billing_module_1 = require("./billing/billing.module");
const admin_module_1 = require("./admin/admin.module");
const users_service_1 = require("./authentication/services/users.service");
const animations_1 = require("@angular/platform-browser/animations");
const snack_bar_1 = require("@angular/material/snack-bar");
const dnaRSnackBar_service_1 = require("./common/dna-r/dnaRSnackBar.service");
const residents_module_1 = require("./residents/residents.module");
const organisation_module_1 = require("./organisation/organisation.module");
const config_1 = require("devextreme/core/config");
const shared_module_1 = require("./common/shared.module");
const dnaR_dropdown_multiSelect_component_1 = require("./common/components/dnaR-dropdown-multiSelect/dnaR-dropdown-multiSelect.component");
const dnaR_checkbox_component_1 = require("./common/components/dnaR-checkbox/dnaR-checkbox.component");
const dnaR_email_input_component_1 = require("./common/components/dnaR-email-input/dnaR-email-input.component");
const dnaR_email_input_module_1 = require("./common/components/dnaR-email-input/dnaR-email-input.module");
const dnaR_timePicker_component_1 = require("./common/components/dnaR-timePicker/dnaR-timePicker.component");
const dnaR_timePicker_module_1 = require("./common/components/dnaR-timePicker/dnaR-timePicker.module");
const dnaR_search_module_1 = require("./common/components/dnaR-search/dnaR-search.module");
const dnaR_alert_component_1 = require("./common/components/dnaR-alert/dnaR-alert.component");
const dnar_alert_module_1 = require("./common/components/dnaR-alert/dnar-alert.module");
const glossary_module_1 = require("./glossary/glossary.module");
const customer_care_module_1 = require("./customer-care/customer-care.module");
const sso_config_module_1 = require("./customer-care/sso-config.module");
const updateDAPAndDACTechOneFacility_module_1 = require("./updateDAPAndDAC/updateDAPAndDACTechOneFacility.module");
const i0 = require("@angular/core");
const i1 = require("@uirouter/angular-hybrid");
const i2 = require("@angular/upgrade/static");
config_1.default({
    forceIsoDateParsing: true
});
//downgrades
angular.module('app')
    .config(['$urlServiceProvider', ($urlService) => $urlService.deferIntercept()])
    .factory('users.service', static_1.downgradeInjectable(users_service_1.UsersService))
    .directive('dnaRDropdownMultiSelect', static_1.downgradeComponent({ component: dnaR_dropdown_multiSelect_component_1.DnaRDropdownMultiSelect }))
    .directive('dnaREmailInput', static_1.downgradeComponent({ component: dnaR_email_input_component_1.DnaREmailInput }))
    .directive('dnaRTimePicker', static_1.downgradeComponent({ component: dnaR_timePicker_component_1.DnaRTimePicker }))
    .directive('dnaRCheckbox', static_1.downgradeComponent({ component: dnaR_checkbox_component_1.DnaRCheckbox }))
    .directive('dnaREmailInput', static_1.downgradeComponent({ component: dnaR_email_input_component_1.DnaREmailInput }))
    .directive('dnaRAlert', static_1.downgradeComponent({ component: dnaR_alert_component_1.DnaRAlertComponent }));
class AppModule {
    constructor(upgradeModule) {
        this.upgradeModule = upgradeModule;
    }
    ngDoBootstrap() {
        this.upgradeModule.bootstrap(document.body, ['app'], { strictDi: true });
    }
}
exports.AppModule = AppModule;
AppModule.ɵmod = i0.ɵɵdefineNgModule({ type: AppModule });
AppModule.ɵinj = i0.ɵɵdefineInjector({ factory: function AppModule_Factory(t) { return new (t || AppModule)(i0.ɵɵinject(i2.UpgradeModule)); }, providers: [
        common_1.DatePipe,
        { provide: snack_bar_1.MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: dnaRSnackBar_service_1.DnaRSnackBarService.DEFAULT_OPTIONS },
        {
            provide: 'authentication.service',
            useFactory: ($injector) => $injector.get('authentication.service'),
            deps: ['$injector']
        }
    ], imports: [[
            platform_browser_1.BrowserModule,
            static_1.UpgradeModule,
            angular_hybrid_1.UIRouterUpgradeModule.forRoot(),
            forms_1.FormsModule,
            http_1.HttpClientModule,
            authentication_module_1.AuthenticationModule,
            dnaR_dropdown_multiSelect_module_1.DnaRDropdownMultiSelectModule,
            dnaR_search_module_1.DnaRSearchModule,
            dnaR_email_input_module_1.DnaREmailInputModule,
            dnaR_timePicker_module_1.DnaRTimePickerModule,
            dnar_alert_module_1.DnaRAlertModule,
            reporting_module_1.ReportingModule,
            billing_module_1.BillingModule,
            admin_module_1.AdminModule,
            animations_1.BrowserAnimationsModule,
            independent_living_module_1.IndependentLivingModule,
            residents_module_1.ResidentsModule,
            shared_module_1.SharedModule,
            organisation_module_1.OrganisationModule,
            glossary_module_1.GlossaryModule,
            customer_care_module_1.CustomerCareModule,
            sso_config_module_1.SsoConfigModule,
            updateDAPAndDACTechOneFacility_module_1.UpdateDAPAndDACTechOneFacilityModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(AppModule, { imports: [platform_browser_1.BrowserModule,
        static_1.UpgradeModule, i1.UIRouterUpgradeModule, forms_1.FormsModule,
        http_1.HttpClientModule,
        authentication_module_1.AuthenticationModule,
        dnaR_dropdown_multiSelect_module_1.DnaRDropdownMultiSelectModule,
        dnaR_search_module_1.DnaRSearchModule,
        dnaR_email_input_module_1.DnaREmailInputModule,
        dnaR_timePicker_module_1.DnaRTimePickerModule,
        dnar_alert_module_1.DnaRAlertModule,
        reporting_module_1.ReportingModule,
        billing_module_1.BillingModule,
        admin_module_1.AdminModule,
        animations_1.BrowserAnimationsModule,
        independent_living_module_1.IndependentLivingModule,
        residents_module_1.ResidentsModule,
        shared_module_1.SharedModule,
        organisation_module_1.OrganisationModule,
        glossary_module_1.GlossaryModule,
        customer_care_module_1.CustomerCareModule,
        sso_config_module_1.SsoConfigModule,
        updateDAPAndDACTechOneFacility_module_1.UpdateDAPAndDACTechOneFacilityModule] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(AppModule, [{
        type: core_1.NgModule,
        args: [{
                imports: [
                    platform_browser_1.BrowserModule,
                    static_1.UpgradeModule,
                    angular_hybrid_1.UIRouterUpgradeModule.forRoot(),
                    forms_1.FormsModule,
                    http_1.HttpClientModule,
                    authentication_module_1.AuthenticationModule,
                    dnaR_dropdown_multiSelect_module_1.DnaRDropdownMultiSelectModule,
                    dnaR_search_module_1.DnaRSearchModule,
                    dnaR_email_input_module_1.DnaREmailInputModule,
                    dnaR_timePicker_module_1.DnaRTimePickerModule,
                    dnar_alert_module_1.DnaRAlertModule,
                    reporting_module_1.ReportingModule,
                    billing_module_1.BillingModule,
                    admin_module_1.AdminModule,
                    animations_1.BrowserAnimationsModule,
                    independent_living_module_1.IndependentLivingModule,
                    residents_module_1.ResidentsModule,
                    shared_module_1.SharedModule,
                    organisation_module_1.OrganisationModule,
                    glossary_module_1.GlossaryModule,
                    customer_care_module_1.CustomerCareModule,
                    sso_config_module_1.SsoConfigModule,
                    updateDAPAndDACTechOneFacility_module_1.UpdateDAPAndDACTechOneFacilityModule
                ],
                declarations: [],
                providers: [
                    common_1.DatePipe,
                    { provide: snack_bar_1.MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: dnaRSnackBar_service_1.DnaRSnackBarService.DEFAULT_OPTIONS },
                    {
                        provide: 'authentication.service',
                        useFactory: ($injector) => $injector.get('authentication.service'),
                        deps: ['$injector']
                    }
                ]
            }]
    }], function () { return [{ type: i2.UpgradeModule }]; }, null); })();
